import React, { useEffect, useRef } from 'react';
import Navbar from '../Navbar/Navbar';
import WorldNuclearDayBanner from './WorldNuclearDayBanner';
import './SiteHeader.css';

/**
 * Renders the announcement banner and the main navbar as a single
 * fixed unit at the top of the viewport, and keeps a CSS custom
 * property (--site-header-height) in sync with the unit's real
 * height. Wherever your page content currently uses a fixed
 * padding/margin to clear the fixed navbar, switch it to
 * `padding-top: var(--site-header-height, 70px);` so it adjusts
 * automatically whether the banner is showing or has been dismissed.
 */
function SiteHeader() {
  const headerRef = useRef(null);

  useEffect(() => {
    const el = headerRef.current;
    if (!el) return;

    const setHeightVar = () => {
      document.documentElement.style.setProperty(
        '--site-header-height',
        `${el.offsetHeight}px`
      );
    };

    setHeightVar();

    // Re-measure on resize (e.g. banner text wraps differently on
    // narrow screens) and whenever the header's own size changes
    // (e.g. the banner is dismissed).
    const resizeObserver = new ResizeObserver(setHeightVar);
    resizeObserver.observe(el);
    window.addEventListener('resize', setHeightVar);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', setHeightVar);
    };
  }, []);

  return (
    <div className="site-header" ref={headerRef}>
      <WorldNuclearDayBanner />
      <Navbar />
    </div>
  );
}

export default SiteHeader;